import styled from 'styled-components';

export const CompleteStatusSpan = styled.span`
    background: #F7FFF0;
    border: 1px solid #1DA212;
    color: #1DA212;
    border-radius: 50px;
    padding: 6px 16px;
    font-size: 0.8rem;
    font-weight: 500;
    display: inline-block;
    min-width: auto;
`;

export const ReadyStatusSpan = styled.span`
    background: #F7FFF0;
    border: 1px solid #1DA212;
    color: #1DA212;
    border-radius: 50px;
    padding: 6px 16px;
    font-size: 0.8rem;
    font-weight: 500;
    display: inline-block;
    min-width: auto;
`;

export const MissingStatusSpan = styled.span`
    background: transparent;
    border: 1px solid #d32f2f;
    color: #d32f2f;
    border-radius: 6px;
    padding: 6px 16px;
    font-size: 0.8rem;
    font-weight: 500;
    display: inline-block;
    min-width: auto;
`;

export const AnalyzingStatusSpan = styled.span`
    background: #fff3e0;
    border: 1px solid #ff9800;
    color: #ff9800;
    border-radius: 15px;
    padding: 6px 16px;
    font-size: 0.8rem;
    font-weight: 500;
    display: inline-block;
    min-width: auto;
    opacity: 0.8;
`;

export const AddButton = styled.button`
    background: transparent;
    border: none;
    color: #225E9F;
    text-decoration: underline;
    font-size: 0.8rem;
    padding: 6px 12px;
    min-width: auto;
    cursor: pointer;
    font-family: inherit;
    font-weight: bold;
    
    &:hover {
        background: rgba(34, 94, 159, 0.04);
    }
    
    &:active {
        background: rgba(34, 94, 159, 0.1);
    }
`;

export const StatusContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;
